import { FunctionalComponent, h } from '@stencil/core';
import LazyloadImage from '../LazyloadImage';
import Text from '../Text';

interface DealIndicatorProps {
    dealType: string;
}

const renderkbbImage = () => {
    return (
        <LazyloadImage
            imageClass="deal-icon media-gallery-viewer order-2"
            height={34}
            width={25}
            src="https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg" //TODO: find out if its okay to use this image (possible CORS issue?) or if we need to host our own
        />
    );
};


const DealIndicator: FunctionalComponent<DealIndicatorProps> = ({ dealType }) => (
    <div>
        {renderkbbImage()}
        <div
            class={`ribbon ribbon-` + dealType.toLowerCase() + `-price`}
        >
            <div class='ribbon-content-right '>
                <Text weight="bold" size='200' content={dealType + ` PRICE`} />
            </div>
        </div>
    </div>
);

export default DealIndicator;